var zone4dCoords190211 = [
{lng: 153.037599, lat: -27.1684313},
{lng: 153.0372419, lat: -27.1626582},
{lng: 153.0290046, lat: -27.1593917},
{lng: 153.024595, lat: -27.1606819},
{lng: 153.0119562, lat: -27.1673442},
{lng: 153.0050459, lat: -27.1656303},
{lng: 153.002214, lat: -27.1693702},
{lng: 152.9909707, lat: -27.1692915},
{lng: 152.9824606, lat: -27.1720432},
{lng: 152.9830742, lat: -27.1868529},
{lng: 152.9531622, lat: -27.1836472},
{lng: 152.9533652, lat: -27.1777483},
{lng: 152.9544967, lat: -27.1725464},
{lng: 152.9563146, lat: -27.1678789},
{lng: 152.9509735, lat: -27.1671535},
{lng: 152.942372, lat: -27.1641382},
{lng: 152.9366552, lat: -27.1643101},
{lng: 152.9343975, lat: -27.1659039},
{lng: 152.9276763, lat: -27.174255},
{lng: 152.9039383, lat: -27.2230363},
{lng: 152.8986172, lat: -27.2381434},
{lng: 152.898361, lat: -27.26317},
{lng: 152.8961722, lat: -27.2760656},
{lng: 152.8816223, lat: -27.283773},
{lng: 152.8769878, lat: -27.2840402},
{lng: 152.8723534, lat: -27.2827817},
{lng: 152.8677187, lat: -27.2827433},
{lng: 152.8666882, lat: -27.2877585},
{lng: 152.867675, lat: -27.2906476},
{lng: 152.8676319, lat: -27.2935367},
{lng: 152.8631698, lat: -27.312526},
{lng: 152.8606805, lat: -27.3156911},
{lng: 152.856217, lat: -27.3195615},
{lng: 152.852773, lat: -27.320665},
{lng: 152.8487281, lat: -27.3193281},
{lng: 152.8469041, lat: -27.3181033},
{lng: 152.8445434, lat: -27.3307527},
{lng: 152.8526982, lat: -27.3444736},
{lng: 152.8642433, lat: -27.3491242},
{lng: 152.8723223, lat: -27.3616641},
{lng: 152.8776392, lat: -27.3755772},
{lng: 152.8807984, lat: -27.3799227},
{lng: 152.8706113, lat: -27.389297},
{lng: 152.855444, lat: -27.3982129},
{lng: 152.8547143, lat: -27.409566},
{lng: 152.8574181, lat: -27.420919},
{lng: 152.8705548, lat: -27.4176347},
{lng: 152.8895256, lat: -27.4204495},
{lng: 152.9004704, lat: -27.4234559},
{lng: 152.9032821, lat: -27.4240447},
{lng: 152.9243392, lat: -27.4272045},
{lng: 152.924824, lat: -27.4217751},
{lng: 152.9285856, lat: -27.422032},
{lng: 152.9305519, lat: -27.4106938},
{lng: 152.9144311, lat: -27.4083393},
{lng: 152.9161048, lat: -27.3933549},
{lng: 152.923207, lat: -27.3928398},
{lng: 152.9276916, lat: -27.3896203},
{lng: 152.9313503, lat: -27.3862196},
{lng: 152.9380102, lat: -27.3822498},
{lng: 152.9482491, lat: -27.3808367},
{lng: 152.9524665, lat: -27.3753663},
{lng: 152.9527479, lat: -27.3676339},
{lng: 152.949253, lat: -27.3597491},
{lng: 152.9506755, lat: -27.3541944},
{lng: 152.9547166, lat: -27.3465648},
{lng: 152.9606453, lat: -27.342442},
{lng: 152.9607582, lat: -27.3369288},
{lng: 152.962862, lat: -27.3243674},
{lng: 152.9602682, lat: -27.3239187},
{lng: 152.9633238, lat: -27.3099871},
{lng: 152.9811353, lat: -27.3061176},
{lng: 152.9822119, lat: -27.3076421},
{lng: 152.9881129, lat: -27.3066874},
{lng: 152.9897127, lat: -27.3109193},
{lng: 152.9918277, lat: -27.3151511},
{lng: 152.9958862, lat: -27.3175139},
{lng: 153.0026892, lat: -27.3193429},
{lng: 152.9986175, lat: -27.3110302},
{lng: 152.9979793, lat: -27.30287},
{lng: 153.0095248, lat: -27.2984466},
{lng: 153.0164341, lat: -27.2885311},
{lng: 153.0240299, lat: -27.2942512},
{lng: 153.0326564, lat: -27.2987505},
{lng: 153.0380307, lat: -27.2813488},
{lng: 153.0729306, lat: -27.280156},
{lng: 153.1085061, lat: -27.2646554},
{lng: 153.1211082, lat: -27.2293126},
{lng: 153.1207448, lat: -27.2087974},
{lng: 153.1191898, lat: -27.1977764},
{lng: 153.116262, lat: -27.1891982},
{lng: 153.1048384, lat: -27.1902319},
{lng: 153.0941481, lat: -27.1979243},
{lng: 153.08071, lat: -27.200119},
{lng: 153.0434403, lat: -27.1924025},
{lng: 153.0338974, lat: -27.1869557},
{lng: 153.0325952, lat: -27.1741791},
{lng: 153.037599, lat: -27.1684313}
];

var zone1Coords190211 = [ 
{lng: 153.035285, lat: -27.4638716},
{lng: 153.0329879, lat: -27.4651563},
{lng: 153.0329706, lat: -27.4701738},
{lng: 153.0331919, lat: -27.4786021},
{lng: 153.0294608, lat: -27.4810087},
{lng: 153.026265, lat: -27.4792801},
{lng: 153.0199468, lat: -27.4712958},
{lng: 153.017236, lat: -27.4688727},
{lng: 153.0131391, lat: -27.4689838},
{lng: 153.0095048, lat: -27.4712671},
{lng: 152.9990491, lat: -27.4809773},
{lng: 152.9963207, lat: -27.4856262},
{lng: 152.9955765, lat: -27.4886386},
{lng: 152.9973126, lat: -27.4909928},
{lng: 153.0073643, lat: -27.4914086},
{lng: 153.0126477, lat: -27.491084},
{lng: 153.0164575, lat: -27.4928304},
{lng: 153.0190659, lat: -27.494729},
{lng: 153.0214708, lat: -27.5005038},
{lng: 153.0209873, lat: -27.502713},
{lng: 153.0113039, lat: -27.5043505},
{lng: 153.0043778, lat: -27.5057868},
{lng: 152.9999759, lat: -27.5099594},
{lng: 152.9988666, lat: -27.5129904},
{lng: 152.9991822, lat: -27.5154996},
{lng: 153.0033094, lat: -27.5162228},
{lng: 153.0084039, lat: -27.5166797},
{lng: 153.0103161, lat: -27.5184098},
{lng: 153.0097759, lat: -27.5217325},
{lng: 153.0008991, lat: -27.5230368},
{lng: 152.9938003, lat: -27.5220894},
{lng: 152.9832991, lat: -27.5124045},
{lng: 152.974874, lat: -27.5061911},
{lng: 152.973538, lat: -27.5054815},
{lng: 152.9717727, lat: -27.5052287},
{lng: 152.9698312, lat: -27.5063684},
{lng: 152.9688337, lat: -27.5081932},
{lng: 152.9667917, lat: -27.512921},
{lng: 152.9672184, lat: -27.5168253},
{lng: 152.9715318, lat: -27.5262278},
{lng: 152.9716777, lat: -27.5300104},
{lng: 152.9706218, lat: -27.5335647},
{lng: 152.9724391, lat: -27.5378423},
{lng: 152.9741281, lat: -27.5398828},
{lng: 152.9742721, lat: -27.5423418},
{lng: 152.9736143, lat: -27.5435998},
{lng: 152.9719265, lat: -27.5444773},
{lng: 152.9687008, lat: -27.5443737},
{lng: 152.9653892, lat: -27.5439657},
{lng: 152.9626358, lat: -27.5413121},
{lng: 152.9610433, lat: -27.5360317},
{lng: 152.9552926, lat: -27.5308853},
{lng: 152.9460233, lat: -27.5273985},
{lng: 152.9374838, lat: -27.5269553},
{lng: 152.9305535, lat: -27.5279443},
{lng: 152.928042, lat: -27.5288863},
{lng: 152.926818, lat: -27.5314267},
{lng: 152.9264867, lat: -27.5394564},
{lng: 152.9240105, lat: -27.5417398},
{lng: 152.9188374, lat: -27.542344},
{lng: 152.9096925, lat: -27.5432833},
{lng: 152.9047505, lat: -27.5439461},
{lng: 152.9031126, lat: -27.5453503},
{lng: 152.9026763, lat: -27.5475916},
{lng: 152.9051388, lat: -27.5512664},
{lng: 152.9061963, lat: -27.5538964},
{lng: 152.9058265, lat: -27.5561449},
{lng: 152.8996858, lat: -27.5585918},
{lng: 152.8966752, lat: -27.5605029},
{lng: 152.8973123, lat: -27.563125},
{lng: 152.9014389, lat: -27.5658326},
{lng: 152.9000728, lat: -27.5696813},
{lng: 152.8955269, lat: -27.5749384},
{lng: 152.8941338, lat: -27.5788123},
{lng: 152.8953157, lat: -27.5823057},
{lng: 152.9008584, lat: -27.5893004},
{lng: 152.9060087, lat: -27.5972083},
{lng: 152.905841, lat: -27.6009131},
{lng: 152.9034416, lat: -27.6021078},
{lng: 152.9052156, lat: -27.6039553},
{lng: 152.9132411, lat: -27.6063292},
{lng: 152.9191858, lat: -27.6061829},
{lng: 152.9237907, lat: -27.6072621},
{lng: 152.92831, lat: -27.6112313},
{lng: 152.9340673, lat: -27.6137004},
{lng: 152.9369925, lat: -27.6173101},
{lng: 152.9400111, lat: -27.6223239},
{lng: 152.9419676, lat: -27.6263339},
{lng: 152.9448027, lat: -27.629753},
{lng: 152.9510702, lat: -27.6333252},
{lng: 152.9605558, lat: -27.6351109},
{lng: 152.9658885, lat: -27.6352151},
{lng: 152.9712213, lat: -27.637296},
{lng: 152.9751266, lat: -27.6423632},
{lng: 152.9796657, lat: -27.6470423},
{lng: 152.9838617, lat: -27.6486798},
{lng: 152.9818722, lat: -27.6609224},
{lng: 152.9909543, lat: -27.6623694},
{lng: 152.9921537, lat: -27.6682641},
{lng: 153.0088984, lat: -27.6705111},
{lng: 153.0076424, lat: -27.6775316},
{lng: 153.0163606, lat: -27.678983},
{lng: 153.0307974, lat: -27.6808468},
{lng: 153.0314815, lat: -27.6868563},
{lng: 153.0490028, lat: -27.6891056},
{lng: 153.0510667, lat: -27.6820212},
{lng: 153.0528709, lat: -27.6742231},
{lng: 153.0569487, lat: -27.6735553},
{lng: 153.0626779, lat: -27.6693066},
{lng: 153.0653547, lat: -27.6692519},
{lng: 153.068203, lat: -27.6682849},
{lng: 153.0736271, lat: -27.6710056},
{lng: 153.0807682, lat: -27.6778308},
{lng: 153.0842976, lat: -27.657931},
{lng: 153.0983776, lat: -27.6532252},
{lng: 153.0999662, lat: -27.6448205},
{lng: 153.0989798, lat: -27.6437528},
{lng: 153.0976496, lat: -27.6424303},
{lng: 153.0964052, lat: -27.6395871},
{lng: 153.0984654, lat: -27.6398235},
{lng: 153.1002142, lat: -27.6393028},
{lng: 153.1015338, lat: -27.638516},
{lng: 153.1025208, lat: -27.6346116},
{lng: 153.1051062, lat: -27.635777},
{lng: 153.1083516, lat: -27.635105},
{lng: 153.1083219, lat: -27.6357956},
{lng: 153.118757, lat: -27.6371483},
{lng: 153.118855, lat: -27.634616},
{lng: 153.1184381, lat: -27.6285097},
{lng: 153.1160168, lat: -27.6232549},
{lng: 153.1179564, lat: -27.6209979},
{lng: 153.1193454, lat: -27.6195119},
{lng: 153.1196771, lat: -27.6177187},
{lng: 153.1207706, lat: -27.6149178},
{lng: 153.1239239, lat: -27.6150829},
{lng: 153.1198401, lat: -27.6071196},
{lng: 153.1135255, lat: -27.5976351},
{lng: 153.1037323, lat: -27.5818591},
{lng: 153.1082882, lat: -27.5690386},
{lng: 153.107842, lat: -27.5631338},
{lng: 153.1174789, lat: -27.5469948},
{lng: 153.117191, lat: -27.5434068},
{lng: 153.111918, lat: -27.5396942},
{lng: 153.1110184, lat: -27.5347777},
{lng: 153.1107394, lat: -27.5296085},
{lng: 153.1087418, lat: -27.5282681},
{lng: 153.1036544, lat: -27.5257098},
{lng: 153.1027303, lat: -27.5227712},
{lng: 153.1030078, lat: -27.5186909},
{lng: 153.0976172, lat: -27.517579},
{lng: 153.0867343, lat: -27.5157823},
{lng: 153.08117, lat: -27.5136563},
{lng: 153.076636, lat: -27.5087898},
{lng: 153.0754851, lat: -27.5039773},
{lng: 153.075965, lat: -27.4995075},
{lng: 153.0684694, lat: -27.4981823},
{lng: 153.0682736, lat: -27.4976346},
{lng: 153.0667225, lat: -27.4969933},
{lng: 153.0654719, lat: -27.4957049},
{lng: 153.0640283, lat: -27.4920754},
{lng: 153.0638604, lat: -27.4898261},
{lng: 153.0628772, lat: -27.4862444},
{lng: 153.0605407, lat: -27.4857653},
{lng: 153.0572268, lat: -27.4803098},
{lng: 153.0516218, lat: -27.4784196},
{lng: 153.0492915, lat: -27.4791497},
{lng: 153.0497936, lat: -27.4756156},
{lng: 153.0460219, lat: -27.4761809},
{lng: 153.0431514, lat: -27.4760988},
{lng: 153.0408612, lat: -27.4736394},
{lng: 153.0393007, lat: -27.4696188},
{lng: 153.0384086, lat: -27.4658313},
{lng: 153.035285, lat: -27.4638716}
];

var zone2Coords190211 = [
{lng: 152.874773, lat: -27.6264979},
{lng: 152.8855558, lat: -27.6278305},
{lng: 152.8911887, lat: -27.6268813},
{lng: 152.8930128, lat: -27.6227014},
{lng: 152.9035275, lat: -27.624683},
{lng: 152.9020265, lat: -27.6269694},
{lng: 152.9039366, lat: -27.6321429},
{lng: 152.9076383, lat: -27.6332849},
{lng: 152.9031003, lat: -27.6371644},
{lng: 152.9171815, lat: -27.6396179},
{lng: 152.9189926, lat: -27.6439926},
{lng: 152.9194071, lat: -27.6472388},
{lng: 152.9218492, lat: -27.6515786},
{lng: 152.9233556, lat: -27.6534597},
{lng: 152.9245456, lat: -27.6575561},
{lng: 152.9316238, lat: -27.6660001},
{lng: 152.9288373, lat: -27.6840201},
{lng: 152.9646786, lat: -27.6912451},
{lng: 152.9721068, lat: -27.6972038},
{lng: 152.9763363, lat: -27.7062625},
{lng: 152.9788498, lat: -27.7138013},
{lng: 152.980081, lat: -27.7179732},
{lng: 152.9849897, lat: -27.7275716},
{lng: 153.0084666, lat: -27.7313076},
{lng: 153.0280412, lat: -27.7335911},
{lng: 153.0305522, lat: -27.7261483},
{lng: 153.060625, lat: -27.7304453},
{lng: 153.0648407, lat: -27.7192102},
{lng: 153.0669065, lat: -27.7129267},
{lng: 153.0750971, lat: -27.70606},
{lng: 153.0776222, lat: -27.6973694},
{lng: 153.0990772, lat: -27.7001809},
{lng: 153.1027704, lat: -27.6916248},
{lng: 153.1112589, lat: -27.6835937},
{lng: 153.1214629, lat: -27.6776901},
{lng: 153.1225417, lat: -27.6702546},
{lng: 153.1193314, lat: -27.6644128},
{lng: 153.1214172, lat: -27.6640011},
{lng: 153.1228163, lat: -27.6626773},
{lng: 153.1252881, lat: -27.6594528},
{lng: 153.1279231, lat: -27.6572972},
{lng: 153.1306438, lat: -27.6560539},
{lng: 153.1358276, lat: -27.6556198},
{lng: 153.1417869, lat: -27.657159},
{lng: 153.1446808, lat: -27.6553246},
{lng: 153.1463852, lat: -27.6542744},
{lng: 153.1486476, lat: -27.6543264},
{lng: 153.1539923, lat: -27.6562295},
{lng: 153.1581083, lat: -27.6589828},
{lng: 153.161366, lat: -27.6590084},
{lng: 153.1634604, lat: -27.6576919},
{lng: 153.1634949, lat: -27.6544369},
{lng: 153.1576882, lat: -27.6497866},
{lng: 153.1634985, lat: -27.6467214},
{lng: 153.164305, lat: -27.64234},
{lng: 153.1610652, lat: -27.6413063},
{lng: 153.1622243, lat: -27.6395151},
{lng: 153.1654104, lat: -27.6372538},
{lng: 153.172676, lat: -27.6385115},
{lng: 153.1741886, lat: -27.6343758},
{lng: 153.1757038, lat: -27.6237288},
{lng: 153.1815102, lat: -27.6238801},
{lng: 153.1841388, lat: -27.6089263},
{lng: 153.1759646, lat: -27.6068315},
{lng: 153.1771277, lat: -27.6044724},
{lng: 153.1769761, lat: -27.6021114},
{lng: 153.1741965, lat: -27.5967803},
{lng: 153.1731906, lat: -27.591612},
{lng: 153.1756448, lat: -27.5883548},
{lng: 153.1803732, lat: -27.5829741},
{lng: 153.1787489, lat: -27.5789614},
{lng: 153.1804779, lat: -27.5741311},
{lng: 153.182523, lat: -27.5640185},
{lng: 153.1902323, lat: -27.5592319},
{lng: 153.1896862, lat: -27.5545286},
{lng: 153.1851611, lat: -27.5512097},
{lng: 153.181776, lat: -27.5451812},
{lng: 153.1726413, lat: -27.5383914},
{lng: 153.1690007, lat: -27.5279482},
{lng: 153.1625109, lat: -27.5268874},
{lng: 153.1575659, lat: -27.5297843},
{lng: 153.1500791, lat: -27.5288798},
{lng: 153.1285165, lat: -27.5218083},
{lng: 153.1257612, lat: -27.5122573},
{lng: 153.1247703, lat: -27.504284},
{lng: 153.1259555, lat: -27.4988999},
{lng: 153.1257673, lat: -27.4943533},
{lng: 153.1244204, lat: -27.4923573},
{lng: 153.121872, lat: -27.4927215},
{lng: 153.1191952, lat: -27.4938851},
{lng: 153.1021844, lat: -27.4915455},
{lng: 153.1009472, lat: -27.4896035},
{lng: 153.0866736, lat: -27.4878805},
{lng: 153.0883774, lat: -27.4776723},
{lng: 153.0813119, lat: -27.4781458},
{lng: 153.0794528, lat: -27.4789916},
{lng: 153.0787636, lat: -27.4782237},
{lng: 153.0778598, lat: -27.4776843},
{lng: 153.0763097, lat: -27.4767959},
{lng: 153.0753554, lat: -27.4756663},
{lng: 153.0743909, lat: -27.4755772},
{lng: 153.0700791, lat: -27.4749168},
{lng: 153.0694681, lat: -27.4777658},
{lng: 153.0684141, lat: -27.4778593},
{lng: 153.0677464, lat: -27.4783716},
{lng: 153.0657053, lat: -27.4781225},
{lng: 153.0657791, lat: -27.4761512},
{lng: 153.0664168, lat: -27.4739853},
{lng: 153.0647095, lat: -27.4737769},
{lng: 153.0639892, lat: -27.4723311},
{lng: 153.0635915, lat: -27.4709371},
{lng: 153.0634298, lat: -27.4701903},
{lng: 153.0644648, lat: -27.4673467},
{lng: 153.0644887, lat: -27.4660104},
{lng: 153.0631823, lat: -27.4609425},
{lng: 153.0631882, lat: -27.4592281},
{lng: 153.0615634, lat: -27.4589987},
{lng: 153.0617255, lat: -27.4571501},
{lng: 153.0585719, lat: -27.4567732},
{lng: 153.057564, lat: -27.4569295},
{lng: 153.0525013, lat: -27.4561374},
{lng: 153.0508152, lat: -27.4517495},
{lng: 153.0491292, lat: -27.4518554},
{lng: 153.0465482, lat: -27.4542501},
{lng: 153.0444392, lat: -27.4537887},
{lng: 153.0409352, lat: -27.4557838},
{lng: 153.0391402, lat: -27.4542678},
{lng: 153.0357302, lat: -27.4517181},
{lng: 153.0341149, lat: -27.4534743},
{lng: 153.0310092, lat: -27.4516659},
{lng: 153.0271388, lat: -27.452742},
{lng: 153.0238088, lat: -27.4540988},
{lng: 153.0227403, lat: -27.4558757},
{lng: 153.0209851, lat: -27.4568909},
{lng: 153.0160538, lat: -27.4573015},
{lng: 153.0130624, lat: -27.4578926},
{lng: 153.012065, lat: -27.4591956},
{lng: 153.0110354, lat: -27.463093},
{lng: 153.0086755, lat: -27.4627289},
{lng: 153.0061007, lat: -27.46357},
{lng: 153.0055697, lat: -27.462438},
{lng: 153.0003179, lat: -27.4643523},
{lng: 153.0010582, lat: -27.4665435},
{lng: 152.9984705, lat: -27.4686909},
{lng: 152.9880234, lat: -27.4685294},
{lng: 152.9878964, lat: -27.4696344},
{lng: 152.9867065, lat: -27.469968},
{lng: 152.986482, lat: -27.4706633},
{lng: 152.9807148, lat: -27.4772897},
{lng: 152.9785174, lat: -27.4782045},
{lng: 152.9689212, lat: -27.4829259},
{lng: 152.964466, lat: -27.4862004},
{lng: 152.9377766, lat: -27.4826409},
{lng: 152.9362981, lat: -27.484383},
{lng: 152.9372228, lat: -27.4874957},
{lng: 152.9347866, lat: -27.4888274},
{lng: 152.9329511, lat: -27.4904637},
{lng: 152.9328892, lat: -27.4914439},
{lng: 152.9361746, lat: -27.4938707},
{lng: 152.9383684, lat: -27.4983435},
{lng: 152.938932, lat: -27.5025117},
{lng: 152.9372708, lat: -27.5043913},
{lng: 152.9265112, lat: -27.5073364},
{lng: 152.9269099, lat: -27.5152305},
{lng: 152.9237625, lat: -27.5232115},
{lng: 152.926818, lat: -27.5314267},
{lng: 152.928042, lat: -27.5288863},
{lng: 152.9305535, lat: -27.5279443},
{lng: 152.9374838, lat: -27.5269553},
{lng: 152.9460233, lat: -27.5273985},
{lng: 152.9552926, lat: -27.5308853},
{lng: 152.9610433, lat: -27.5360317},
{lng: 152.9626358, lat: -27.5413121},
{lng: 152.9653892, lat: -27.5439657},
{lng: 152.9687008, lat: -27.5443737},
{lng: 152.9719265, lat: -27.5444773},
{lng: 152.9736143, lat: -27.5435998},
{lng: 152.9742721, lat: -27.5423418},
{lng: 152.9741281, lat: -27.5398828},
{lng: 152.9724391, lat: -27.5378423},
{lng: 152.9706218, lat: -27.5335647},
{lng: 152.9716777, lat: -27.5300104},
{lng: 152.9715318, lat: -27.5262278},
{lng: 152.9672184, lat: -27.5168253},
{lng: 152.9667917, lat: -27.512921},
{lng: 152.9698312, lat: -27.5063684},
{lng: 152.9717727, lat: -27.5052287},
{lng: 152.973538, lat: -27.5054815},
{lng: 152.974874, lat: -27.5061911},
{lng: 152.9832991, lat: -27.5124045},
{lng: 152.9938003, lat: -27.5220894},
{lng: 153.0008991, lat: -27.5230368},
{lng: 153.0097759, lat: -27.5217325},
{lng: 153.0103161, lat: -27.5184098},
{lng: 153.0084039, lat: -27.5166797},
{lng: 153.0033094, lat: -27.5162228},
{lng: 152.9991822, lat: -27.5154996},
{lng: 152.9988666, lat: -27.5129904},
{lng: 152.9999759, lat: -27.5099594},
{lng: 153.0043778, lat: -27.5057868},
{lng: 153.0113039, lat: -27.5043505},
{lng: 153.0209873, lat: -27.502713},
{lng: 153.0214708, lat: -27.5005038},
{lng: 153.0190659, lat: -27.494729},
{lng: 153.0164575, lat: -27.4928304},
{lng: 153.0126477, lat: -27.491084},
{lng: 153.0073643, lat: -27.4914086},
{lng: 152.9973126, lat: -27.4909928},
{lng: 152.9955765, lat: -27.4886386},
{lng: 152.9963207, lat: -27.4856262},
{lng: 152.9990491, lat: -27.4809773},
{lng: 153.0095048, lat: -27.4712671},
{lng: 153.0131391, lat: -27.4689838},
{lng: 153.017236, lat: -27.4688727},
{lng: 153.0199468, lat: -27.4712958},
{lng: 153.026265, lat: -27.4792801},
{lng: 153.0294608, lat: -27.4810087},
{lng: 153.0331919, lat: -27.4786021},
{lng: 153.0329879, lat: -27.4651563},
{lng: 153.035285, lat: -27.4638716},
{lng: 153.0384086, lat: -27.4658313},
{lng: 153.0393007, lat: -27.4696188},
{lng: 153.0408612, lat: -27.4736394},
{lng: 153.0431514, lat: -27.4760988},
{lng: 153.0460219, lat: -27.4761809},
{lng: 153.0497936, lat: -27.4756156},
{lng: 153.0492915, lat: -27.4791497},
{lng: 153.0516218, lat: -27.4784196},
{lng: 153.0572268, lat: -27.4803098},
{lng: 153.0605407, lat: -27.4857653},
{lng: 153.0628772, lat: -27.4862444},
{lng: 153.0638604, lat: -27.4898261},
{lng: 153.0640283, lat: -27.4920754},
{lng: 153.0654719, lat: -27.4957049},
{lng: 153.0667225, lat: -27.4969933},
{lng: 153.0682736, lat: -27.4976346},
{lng: 153.0684694, lat: -27.4981823},
{lng: 153.075965, lat: -27.4995075},
{lng: 153.0754851, lat: -27.5039773},
{lng: 153.076636, lat: -27.5087898},
{lng: 153.08117, lat: -27.5136563},
{lng: 153.0867343, lat: -27.5157823},
{lng: 153.0976172, lat: -27.517579},
{lng: 153.1030078, lat: -27.5186909},
{lng: 153.1027303, lat: -27.5227712},
{lng: 153.1036544, lat: -27.5257098},
{lng: 153.1107394, lat: -27.5296085},
{lng: 153.1110184, lat: -27.5347777},
{lng: 153.111918, lat: -27.5396942},
{lng: 153.117191, lat: -27.5434068},
{lng: 153.1174789, lat: -27.5469948},
{lng: 153.107842, lat: -27.5631338},
{lng: 153.1082882, lat: -27.5690386},
{lng: 153.1037323, lat: -27.5818591},
{lng: 153.1198401, lat: -27.6071196},
{lng: 153.1239239, lat: -27.6150829},
{lng: 153.1207706, lat: -27.6149178},
{lng: 153.1196771, lat: -27.6177187},
{lng: 153.1193454, lat: -27.6195119},
{lng: 153.1160168, lat: -27.6232549},
{lng: 153.1184381, lat: -27.6285097},
{lng: 153.1190267, lat: -27.6339696},
{lng: 153.118757, lat: -27.6371483},
{lng: 153.1083219, lat: -27.6357956},
{lng: 153.1083516, lat: -27.635105},
{lng: 153.1051062, lat: -27.635777},
{lng: 153.1025208, lat: -27.6346116},
{lng: 153.1015338, lat: -27.638516},
{lng: 153.1002142, lat: -27.6393028},
{lng: 153.0984654, lat: -27.6398235},
{lng: 153.0964052, lat: -27.6395871},
{lng: 153.0976496, lat: -27.6424303},
{lng: 153.0999662, lat: -27.6448205},
{lng: 153.0983776, lat: -27.6532252},
{lng: 153.0842976, lat: -27.657931},
{lng: 153.0807682, lat: -27.6778308},
{lng: 153.0746675, lat: -27.672083},
{lng: 153.0736271, lat: -27.6710056},
{lng: 153.068203, lat: -27.6682849},
{lng: 153.0653547, lat: -27.6692519},
{lng: 153.0626779, lat: -27.6693066},
{lng: 153.0569487, lat: -27.6735553},
{lng: 153.0528709, lat: -27.6742231},
{lng: 153.0510667, lat: -27.6820212},
{lng: 153.0490028, lat: -27.6891056},
{lng: 153.0314815, lat: -27.6868563},
{lng: 153.0307974, lat: -27.6808468},
{lng: 153.0163606, lat: -27.678983},
{lng: 153.0076424, lat: -27.6775316},
{lng: 153.0088984, lat: -27.6705111},
{lng: 152.9921537, lat: -27.6682641},
{lng: 152.9909543, lat: -27.6623694},
{lng: 152.9818722, lat: -27.6609224},
{lng: 152.9838617, lat: -27.6486798},
{lng: 152.9796657, lat: -27.6470423},
{lng: 152.9751266, lat: -27.6423632},
{lng: 152.9712213, lat: -27.637296},
{lng: 152.9658885, lat: -27.6352151},
{lng: 152.9605558, lat: -27.6351109},
{lng: 152.9510702, lat: -27.6333252},
{lng: 152.9448027, lat: -27.629753},
{lng: 152.9419676, lat: -27.6263339},
{lng: 152.9400111, lat: -27.6223239},
{lng: 152.9369925, lat: -27.6173101},
{lng: 152.9340673, lat: -27.6137004},
{lng: 152.92831, lat: -27.6112313},
{lng: 152.9237907, lat: -27.6072621},
{lng: 152.9191858, lat: -27.6061829},
{lng: 152.9132411, lat: -27.6063292},
{lng: 152.9052156, lat: -27.6039553},
{lng: 152.9034416, lat: -27.6021078},
{lng: 152.8981914, lat: -27.602352},
{lng: 152.8932695, lat: -27.5977882},
{lng: 152.8889614, lat: -27.5900754},
{lng: 152.8765863, lat: -27.5800038},
{lng: 152.8728416, lat: -27.579917},
{lng: 152.8703906, lat: -27.5808618},
{lng: 152.8623597, lat: -27.5971735},
{lng: 152.8597983, lat: -27.597512},
{lng: 152.8573188, lat: -27.596893},
{lng: 152.8562697, lat: -27.5946463},
{lng: 152.8560791, lat: -27.5895091},
{lng: 152.8554593, lat: -27.5846},
{lng: 152.8545272, lat: -27.5829918},
{lng: 152.8529943, lat: -27.5827149},
{lng: 152.8490515, lat: -27.5824626},
{lng: 152.84487, lat: -27.5810336},
{lng: 152.8406885, lat: -27.5799088},
{lng: 152.8343211, lat: -27.5791236},
{lng: 152.8321138, lat: -27.5797483},
{lng: 152.8299708, lat: -27.5798215},
{lng: 152.8286947, lat: -27.5795255},
{lng: 152.8277833, lat: -27.5785639},
{lng: 152.8270007, lat: -27.5770886},
{lng: 152.8256387, lat: -27.5766594},
{lng: 152.8242021, lat: -27.5773795},
{lng: 152.8237954, lat: -27.5794309},
{lng: 152.8216087, lat: -27.5802244},
{lng: 152.8163038, lat: -27.5791483},
{lng: 152.8142603, lat: -27.5824085},
{lng: 152.8196411, lat: -27.5854406},
{lng: 152.8234773, lat: -27.5892333},
{lng: 152.8292087, lat: -27.5901023},
{lng: 152.8285032, lat: -27.5996812},
{lng: 152.823687, lat: -27.6029493},
{lng: 152.81879, lat: -27.6050765},
{lng: 152.820398, lat: -27.6079566},
{lng: 152.8202894, lat: -27.6101522},
{lng: 152.8196229, lat: -27.6132037},
{lng: 152.8230662, lat: -27.6173153},
{lng: 152.8189063, lat: -27.6263472},
{lng: 152.8140591, lat: -27.6315766},
{lng: 152.8206516, lat: -27.6351302},
{lng: 152.8322227, lat: -27.636402},
{lng: 152.8388859, lat: -27.6394012},
{lng: 152.8441445, lat: -27.6393163},
{lng: 152.849632, lat: -27.6405117},
{lng: 152.8538778, lat: -27.636623},
{lng: 152.8588949, lat: -27.6373688},
{lng: 152.8590861, lat: -27.6348142},
{lng: 152.8603929, lat: -27.6333241},
{lng: 152.8614188, lat: -27.632321},
{lng: 152.8624447, lat: -27.631698},
{lng: 152.8649172, lat: -27.6285218},
{lng: 152.8660854, lat: -27.6250591},
{lng: 152.874773, lat: -27.6264979}
];

var zone3Cords190211 = [ // 190211 DONE
{lng: 152.9377766, lat: -27.4826409},
{lng: 152.9362981, lat: -27.484383},
{lng: 152.9372228, lat: -27.4874957},
{lng: 152.9347866, lat: -27.4888274},
{lng: 152.9329511, lat: -27.4904637},
{lng: 152.9328892, lat: -27.4914439},
{lng: 152.9361746, lat: -27.4938707},
{lng: 152.9383684, lat: -27.4983435},
{lng: 152.938932, lat: -27.5025117},
{lng: 152.9372708, lat: -27.5043913},
{lng: 152.9265112, lat: -27.5073364},
{lng: 152.9269099, lat: -27.5152305},
{lng: 152.9237625, lat: -27.5232115},
{lng: 152.926818, lat: -27.5314267},
{lng: 152.9264867, lat: -27.5394564},
{lng: 152.9240105, lat: -27.5417398},
{lng: 152.9047505, lat: -27.5439461},
{lng: 152.9031126, lat: -27.5453503},
{lng: 152.9026763, lat: -27.5475916},
{lng: 152.9051388, lat: -27.5512664},
{lng: 152.9061963, lat: -27.5538964},
{lng: 152.8888632, lat: -27.5517532},
{lng: 152.8898233, lat: -27.5423272},
{lng: 152.877566, lat: -27.5421854},
{lng: 152.8759408, lat: -27.5344044},
{lng: 152.8803347, lat: -27.510148},
{lng: 152.8841524, lat: -27.4982074},
{lng: 152.8920492, lat: -27.4867339},
{lng: 152.9035483, lat: -27.4821358},
{lng: 152.922941, lat: -27.4769759},
{lng: 152.9218182, lat: -27.4621017},
{lng: 152.9032821, lat: -27.4240447},
{lng: 152.9243392, lat: -27.4272045},
{lng: 152.924824, lat: -27.4217751},
{lng: 152.9285856, lat: -27.422032},
{lng: 152.9305519, lat: -27.4106938},
{lng: 152.9144311, lat: -27.4083393},
{lng: 152.9161048, lat: -27.3933549},
{lng: 152.923207, lat: -27.3928398},
{lng: 152.9276916, lat: -27.3896203},
{lng: 152.9313503, lat: -27.3862196},
{lng: 152.9380102, lat: -27.3822498},
{lng: 152.9482491, lat: -27.3808367},
{lng: 152.9524665, lat: -27.3753663},
{lng: 152.9527479, lat: -27.3676339},
{lng: 152.949253, lat: -27.3597491},
{lng: 152.9506755, lat: -27.3541944},
{lng: 152.9547166, lat: -27.3465648},
{lng: 152.9606453, lat: -27.342442},
{lng: 152.9607582, lat: -27.3369288},
{lng: 152.962862, lat: -27.3243674},
{lng: 152.9602682, lat: -27.3239187},
{lng: 152.9623614, lat: -27.3143523},
{lng: 152.9633238, lat: -27.3099871},
{lng: 152.9811353, lat: -27.3061176},
{lng: 152.9822119, lat: -27.3076421},
{lng: 152.9881129, lat: -27.3066874},
{lng: 152.9897127, lat: -27.3109193},
{lng: 152.9918277, lat: -27.3151511},
{lng: 152.9958862, lat: -27.3175139},
{lng: 153.0026892, lat: -27.3193429},
{lng: 152.9986175, lat: -27.3110302},
{lng: 152.9979793, lat: -27.30287},
{lng: 153.003323, lat: -27.3008109},
{lng: 153.0095248, lat: -27.2984466},
{lng: 153.0164341, lat: -27.2885311},
{lng: 153.0240299, lat: -27.2942512},
{lng: 153.0326564, lat: -27.2987505},
{lng: 153.0380307, lat: -27.2813488},
{lng: 153.0729306, lat: -27.280156},
{lng: 153.0892077, lat: -27.3328086},
{lng: 153.1150817, lat: -27.3498135},
{lng: 153.1363678, lat: -27.3581992},
{lng: 153.147418, lat: -27.3587712},
{lng: 153.1564086, lat: -27.3614769},
{lng: 153.1581039, lat: -27.3724912},
{lng: 153.1615162, lat: -27.3774075},
{lng: 153.1544139, lat: -27.3841142},
{lng: 153.153491, lat: -27.3917353},
{lng: 153.1464958, lat: -27.4111667},
{lng: 153.1402303, lat: -27.4213},
{lng: 153.1236644, lat: -27.4298326},
{lng: 153.1065413, lat: -27.4432395},
{lng: 153.1162173, lat: -27.4489902},
{lng: 153.1229007, lat: -27.4612727},
{lng: 153.1470538, lat: -27.4653954},
{lng: 153.1501001, lat: -27.4697474},
{lng: 153.1451641, lat: -27.474937},
{lng: 153.1538702, lat: -27.4762398},
{lng: 153.1590574, lat: -27.474877},
{lng: 153.1658699, lat: -27.4760723},
{lng: 153.1718945, lat: -27.4807056},
{lng: 153.1687354, lat: -27.4878517},
{lng: 153.1689027, lat: -27.493357},
{lng: 153.1717761, lat: -27.4938161},
{lng: 153.1732401, lat: -27.4954774},
{lng: 153.1747447, lat: -27.4957941},
{lng: 153.1761205, lat: -27.4980141},
{lng: 153.1773594, lat: -27.500056},
{lng: 153.1848454, lat: -27.501686},
{lng: 153.1864951, lat: -27.505143},
{lng: 153.2043251, lat: -27.5143756},
{lng: 153.2108264, lat: -27.5156904},
{lng: 153.2098607, lat: -27.5213434},
{lng: 153.2075299, lat: -27.5354332},
{lng: 153.2216429, lat: -27.5476537},
{lng: 153.2268125, lat: -27.5493499},
{lng: 153.2314575, lat: -27.5524809},
{lng: 153.2337802, lat: -27.5592969},
{lng: 153.234942, lat: -27.5663561},
{lng: 153.2326046, lat: -27.5790158},
{lng: 153.2314357, lat: -27.585954},
{lng: 153.2282167, lat: -27.5892836},
{lng: 153.2296968, lat: -27.6012938},
{lng: 153.2336987, lat: -27.6056261},
{lng: 153.2355284, lat: -27.6141812},
{lng: 153.2373016, lat: -27.6263679},
{lng: 153.235785, lat: -27.6315487},
{lng: 153.235985, lat: -27.6342961},
{lng: 153.2401931, lat: -27.6373136},
{lng: 153.2393395, lat: -27.6427416},
{lng: 153.2386624, lat: -27.6505578},
{lng: 153.2325302, lat: -27.6630373},
{lng: 153.2260529, lat: -27.6817501},
{lng: 153.2407764, lat: -27.6875414},
{lng: 153.2450487, lat: -27.6915008},
{lng: 153.2408763, lat: -27.6956846},
{lng: 153.2350703, lat: -27.6946592},
{lng: 153.2334546, lat: -27.6959703},
{lng: 153.2361657, lat: -27.7036934},
{lng: 153.2322856, lat: -27.7061111},
{lng: 153.2336928, lat: -27.7103595},
{lng: 153.2297785, lat: -27.7118723},
{lng: 153.2267608, lat: -27.7154348},
{lng: 153.2168766, lat: -27.7150458},
{lng: 153.2135868, lat: -27.7236895},
{lng: 153.1953937, lat: -27.7216254},
{lng: 153.1919618, lat: -27.7289501},
{lng: 153.1844097, lat: -27.7286771},
{lng: 153.1629781, lat: -27.7259029},
{lng: 153.1597435, lat: -27.7206964},
{lng: 153.1242946, lat: -27.7150169},
{lng: 153.122706, lat: -27.7212931},
{lng: 153.115967, lat: -27.7266574},
{lng: 153.1146766, lat: -27.7325234},
{lng: 153.1195662, lat: -27.73687},
{lng: 153.1209332, lat: -27.7406251},
{lng: 153.1195537, lat: -27.7440763},
{lng: 153.1107841, lat: -27.750294},
{lng: 153.1037303, lat: -27.7565112},
{lng: 153.1024967, lat: -27.7613509},
{lng: 153.1032041, lat: -27.7673577},
{lng: 153.1002961, lat: -27.7713484},
{lng: 153.0969538, lat: -27.7716728},
{lng: 153.0949393, lat: -27.7665947},
{lng: 153.0912084, lat: -27.7659214},
{lng: 153.0866143, lat: -27.7695802},
{lng: 153.0825758, lat: -27.770366},
{lng: 153.0700361, lat: -27.7631265},
{lng: 153.0655651, lat: -27.7593799},
{lng: 153.0639324, lat: -27.7567344},
{lng: 153.0647673, lat: -27.7545255},
{lng: 153.0672723, lat: -27.7526496},
{lng: 153.0690692, lat: -27.7517231},
{lng: 153.0692863, lat: -27.7506854},
{lng: 153.0686451, lat: -27.7502554},
{lng: 153.0647235, lat: -27.7505347},
{lng: 153.0597986, lat: -27.7520049},
{lng: 153.0567618, lat: -27.754994},
{lng: 153.0518591, lat: -27.767401},
{lng: 153.0500753, lat: -27.7699331},
{lng: 153.0474331, lat: -27.7718576},
{lng: 153.0462407, lat: -27.7729717},
{lng: 153.0445333, lat: -27.773782},
{lng: 153.0429976, lat: -27.7745922},
{lng: 153.0412902, lat: -27.7737318},
{lng: 153.0413273, lat: -27.7699478},
{lng: 153.0394761, lat: -27.7661638},
{lng: 153.0350768, lat: -27.7620266},
{lng: 153.0327375, lat: -27.7622943},
{lng: 153.032007, lat: -27.7664754},
{lng: 153.0324341, lat: -27.7719512},
{lng: 153.0293397, lat: -27.7786496},
{lng: 153.026069, lat: -27.7789845},
{lng: 153.0234754, lat: -27.7802617},
{lng: 153.0234378, lat: -27.7853982},
{lng: 153.0228849, lat: -27.7877252},
{lng: 153.0216454, lat: -27.7891409},
{lng: 153.0175453, lat: -27.7879695},
{lng: 153.0163836, lat: -27.7842593},
{lng: 153.0150902, lat: -27.7830652},
{lng: 153.0121596, lat: -27.785385},
{lng: 153.0041523, lat: -27.7819745},
{lng: 152.9810298, lat: -27.7782673},
{lng: 152.980395, lat: -27.7816973},
{lng: 152.962395, lat: -27.7791785},
{lng: 152.965339, lat: -27.7639012},
{lng: 152.9430215, lat: -27.7611382},
{lng: 152.9369381, lat: -27.7599003},
{lng: 152.934331, lat: -27.7576749},
{lng: 152.9327646, lat: -27.7532619},
{lng: 152.9316276, lat: -27.7511846},
{lng: 152.9289885, lat: -27.749601},
{lng: 152.9155564, lat: -27.746889},
{lng: 152.9138408, lat: -27.7440624},
{lng: 152.9131565, lat: -27.7412958},
{lng: 152.9175381, lat: -27.7193458},
{lng: 152.9171121, lat: -27.713048},
{lng: 152.9124841, lat: -27.708203},
{lng: 152.900218, lat: -27.7021772},
{lng: 152.8961931, lat: -27.6947825},
{lng: 152.893861, lat: -27.6731124},
{lng: 152.8838055, lat: -27.6709005},
{lng: 152.8770845, lat: -27.6739251},
{lng: 152.8651882, lat: -27.6772366},
{lng: 152.8468911, lat: -27.6739756},
{lng: 152.8383639, lat: -27.6685621},
{lng: 152.835159, lat: -27.6584353},
{lng: 152.8335735, lat: -27.6476601},
{lng: 152.8354213, lat: -27.6377972},
{lng: 152.8388859, lat: -27.6394012},
{lng: 152.8441445, lat: -27.6393163},
{lng: 152.849632, lat: -27.6405117},
{lng: 152.8538778, lat: -27.636623},
{lng: 152.8588949, lat: -27.6373688},
{lng: 152.8590861, lat: -27.6348142},
{lng: 152.8603929, lat: -27.6333241},
{lng: 152.8614188, lat: -27.632321},
{lng: 152.8624447, lat: -27.631698},
{lng: 152.8649172, lat: -27.6285218},
{lng: 152.8660854, lat: -27.6250591},
{lng: 152.8855558, lat: -27.6278305},
{lng: 152.8911887, lat: -27.6268813},
{lng: 152.8930128, lat: -27.6227014},
{lng: 152.9035275, lat: -27.624683},
{lng: 152.9020265, lat: -27.6269694},
{lng: 152.9039366, lat: -27.6321429},
{lng: 152.9076383, lat: -27.6332849},
{lng: 152.9031003, lat: -27.6371644},
{lng: 152.9171815, lat: -27.6396179},
{lng: 152.9189926, lat: -27.6439926},
{lng: 152.9194071, lat: -27.6472388},
{lng: 152.9218492, lat: -27.6515786},
{lng: 152.9236696, lat: -27.6541108},
{lng: 152.9245456, lat: -27.6575561},
{lng: 152.9316238, lat: -27.6660001},
{lng: 152.9288373, lat: -27.6840201},
{lng: 152.9646786, lat: -27.6912451},
{lng: 152.9721068, lat: -27.6972038},
{lng: 152.9763363, lat: -27.7062625},
{lng: 152.980081, lat: -27.7179732},
{lng: 152.9849897, lat: -27.7275716},
{lng: 153.0084666, lat: -27.7313076},
{lng: 153.0280412, lat: -27.7335911},
{lng: 153.0305522, lat: -27.7261483},
{lng: 153.060625, lat: -27.7304453},
{lng: 153.0669065, lat: -27.7129267},
{lng: 153.0750971, lat: -27.70606},
{lng: 153.0776222, lat: -27.6973694},
{lng: 153.0990772, lat: -27.7001809},
{lng: 153.1027704, lat: -27.6916248},
{lng: 153.1112589, lat: -27.6835937},
{lng: 153.1214629, lat: -27.6776901},
{lng: 153.1225417, lat: -27.6702546},
{lng: 153.1193314, lat: -27.6644128},
{lng: 153.1214172, lat: -27.6640011},
{lng: 153.1252881, lat: -27.6594528},
{lng: 153.1279231, lat: -27.6572972},
{lng: 153.1306438, lat: -27.6560539},
{lng: 153.1358276, lat: -27.6556198},
{lng: 153.1417869, lat: -27.657159},
{lng: 153.1463852, lat: -27.6542744},
{lng: 153.1486476, lat: -27.6543264},
{lng: 153.1539923, lat: -27.6562295},
{lng: 153.1581083, lat: -27.6589828},
{lng: 153.161366, lat: -27.6590084},
{lng: 153.1634604, lat: -27.6576919},
{lng: 153.1634949, lat: -27.6544369},
{lng: 153.1576882, lat: -27.6497866},
{lng: 153.1634985, lat: -27.6467214},
{lng: 153.164305, lat: -27.64234},
{lng: 153.1610652, lat: -27.6413063},
{lng: 153.1622243, lat: -27.6395151},
{lng: 153.1654104, lat: -27.6372538},
{lng: 153.172676, lat: -27.6385115},
{lng: 153.1741886, lat: -27.6343758},
{lng: 153.1757038, lat: -27.6237288},
{lng: 153.1815102, lat: -27.6238801},
{lng: 153.1841388, lat: -27.6089263},
{lng: 153.1759646, lat: -27.6068315},
{lng: 153.1771277, lat: -27.6044724},
{lng: 153.1769761, lat: -27.6021114},
{lng: 153.1741965, lat: -27.5967803},
{lng: 153.1731906, lat: -27.591612},
{lng: 153.1756448, lat: -27.5883548},
{lng: 153.1803732, lat: -27.5829741},
{lng: 153.1787489, lat: -27.5789614},
{lng: 153.1804779, lat: -27.5741311},
{lng: 153.182523, lat: -27.5640185},
{lng: 153.1902323, lat: -27.5592319},
{lng: 153.1896862, lat: -27.5545286},
{lng: 153.1851611, lat: -27.5512097},
{lng: 153.181776, lat: -27.5451812},
{lng: 153.1726413, lat: -27.5383914},
{lng: 153.1690007, lat: -27.5279482},
{lng: 153.1625109, lat: -27.5268874},
{lng: 153.1575659, lat: -27.5297843},
{lng: 153.1500791, lat: -27.5288798},
{lng: 153.1285165, lat: -27.5218083},
{lng: 153.1257612, lat: -27.5122573},
{lng: 153.1247703, lat: -27.504284},
{lng: 153.1259555, lat: -27.4988999},
{lng: 153.1257673, lat: -27.4943533},
{lng: 153.1244204, lat: -27.4923573},
{lng: 153.121872, lat: -27.4927215},
{lng: 153.1191952, lat: -27.4938851},
{lng: 153.1021844, lat: -27.4915455},
{lng: 153.1009472, lat: -27.4896035},
{lng: 153.0866736, lat: -27.4878805},
{lng: 153.0883774, lat: -27.4776723},
{lng: 153.0813119, lat: -27.4781458},
{lng: 153.0794528, lat: -27.4789916},
{lng: 153.0787636, lat: -27.4782237},
{lng: 153.0765752, lat: -27.4769579},
{lng: 153.0753554, lat: -27.4756663},
{lng: 153.0700791, lat: -27.4749168},
{lng: 153.0694681, lat: -27.4777658},
{lng: 153.0684141, lat: -27.4778593},
{lng: 153.0677464, lat: -27.4783716},
{lng: 153.0657053, lat: -27.4781225},
{lng: 153.0657791, lat: -27.4761512},
{lng: 153.0664168, lat: -27.4739853},
{lng: 153.0647095, lat: -27.4737769},
{lng: 153.0639892, lat: -27.4723311},
{lng: 153.0634298, lat: -27.4701903},
{lng: 153.0644648, lat: -27.4673467},
{lng: 153.0644887, lat: -27.4660104},
{lng: 153.0631823, lat: -27.4609425},
{lng: 153.0631882, lat: -27.4592281},
{lng: 153.0615634, lat: -27.4589987},
{lng: 153.0617255, lat: -27.4571501},
{lng: 153.0585719, lat: -27.4567732},
{lng: 153.057564, lat: -27.4569295},
{lng: 153.0525013, lat: -27.4561374},
{lng: 153.0508152, lat: -27.4517495},
{lng: 153.0491292, lat: -27.4518554},
{lng: 153.0465482, lat: -27.4542501},
{lng: 153.0444392, lat: -27.4537887},
{lng: 153.0409352, lat: -27.4557838},
{lng: 153.0357302, lat: -27.4517181},
{lng: 153.0341149, lat: -27.4534743},
{lng: 153.0310092, lat: -27.4516659},
{lng: 153.0271388, lat: -27.452742},
{lng: 153.0238088, lat: -27.4540988},
{lng: 153.0227403, lat: -27.4558757},
{lng: 153.0209851, lat: -27.4568909},
{lng: 153.0160538, lat: -27.4573015},
{lng: 153.0130624, lat: -27.4578926},
{lng: 153.012065, lat: -27.4591956},
{lng: 153.0110354, lat: -27.463093},
{lng: 153.0086755, lat: -27.4627289},
{lng: 153.0061007, lat: -27.46357},
{lng: 153.0055697, lat: -27.462438},
{lng: 153.0003179, lat: -27.4643523},
{lng: 153.0010582, lat: -27.4665435},
{lng: 152.9984705, lat: -27.4686909},
{lng: 152.9880234, lat: -27.4685294},
{lng: 152.9878964, lat: -27.4696344},
{lng: 152.9867065, lat: -27.469968},
{lng: 152.986482, lat: -27.4706633},
{lng: 152.9807148, lat: -27.4772897},
{lng: 152.9689212, lat: -27.4829259},
{lng: 152.964466, lat: -27.4862004},
{lng: 152.9377766, lat: -27.4826409}
];

var zone3_WestCoords190211 = [
{lng: 152.8140591, lat: -27.6315766},
{lng: 152.8086662, lat: -27.635254},
{lng: 152.8014565, lat: -27.6370029},
{lng: 152.7939034, lat: -27.6416411},
{lng: 152.7913284, lat: -27.6382955},
{lng: 152.7914143, lat: -27.6341134},
{lng: 152.7921867, lat: -27.6318322},
{lng: 152.7891827, lat: -27.6303113},
{lng: 152.784462, lat: -27.6291707},
{lng: 152.7828312, lat: -27.624532},
{lng: 152.778765, lat: -27.6239426},
{lng: 152.7800309, lat: -27.6164517},
{lng: 152.7828526, lat: -27.6168511},
{lng: 152.7834749, lat: -27.6136236},
{lng: 152.7828312, lat: -27.6135237},
{lng: 152.7839309, lat: -27.607943},
{lng: 152.782799, lat: -27.6077433},
{lng: 152.783362, lat: -27.6039118},
{lng: 152.7881926, lat: -27.6032892},
{lng: 152.7898157, lat: -27.6017186},
{lng: 152.7902371, lat: -27.5990832},
{lng: 152.788384, lat: -27.5974749},
{lng: 152.781106, lat: -27.598268},
{lng: 152.7794929, lat: -27.5958659},
{lng: 152.7810226, lat: -27.5918498},
{lng: 152.7841509, lat: -27.5885852},
{lng: 152.7859917, lat: -27.5856248},
{lng: 152.7958601, lat: -27.5828362},
{lng: 152.8041247, lat: -27.5828238},
{lng: 152.8096035, lat: -27.5833316},
{lng: 152.8115274, lat: -27.5864383},
{lng: 152.8148622, lat: -27.5859788},
{lng: 152.8142603, lat: -27.5824085},
{lng: 152.8196411, lat: -27.5854406},
{lng: 152.8234773, lat: -27.5892333},
{lng: 152.8292087, lat: -27.5901023},
{lng: 152.8285032, lat: -27.5996812},
{lng: 152.823687, lat: -27.6029493},
{lng: 152.81879, lat: -27.6050765},
{lng: 152.820398, lat: -27.6079566},
{lng: 152.8196229, lat: -27.6132037},
{lng: 152.8230662, lat: -27.6173153},
{lng: 152.8189063, lat: -27.6263472},
{lng: 152.8140591, lat: -27.6315766}
];


var zone4aCoords190211 = [
  {lng: 152.962395, lat: -27.7791785},
{lng: 152.9458522, lat: -27.8120166},
{lng: 152.9470283, lat: -27.8156452},
{lng: 152.9523244, lat: -27.818059},
{lng: 152.9639475, lat: -27.8250118},
{lng: 152.9861663, lat: -27.8310205},
{lng: 152.9936271, lat: -27.8436277},
{lng: 153.055687, lat: -27.8600216},
{lng: 153.1040955, lat: -27.8269319},
{lng: 153.098259, lat: -27.8172156},
{lng: 153.0996323, lat: -27.7999062},
{lng: 153.1003189, lat: -27.7938321},
{lng: 153.1767941, lat: -27.800134},
{lng: 153.19025, lat: -27.778318},
{lng: 153.208642, lat: -27.7734835},
{lng: 153.2216112, lat: -27.7725813},
{lng: 153.2287995, lat: -27.7743299},
{lng: 153.2296394, lat: -27.7698494},
{lng: 153.2334804, lat: -27.7663557},
{lng: 153.2441546, lat: -27.7612667},
{lng: 153.2405635, lat: -27.7553029},
{lng: 153.2434019, lat: -27.7516381},
{lng: 153.258124, lat: -27.7491978},
{lng: 153.265525, lat: -27.7385138},
{lng: 153.2692242, lat: -27.7209398},
{lng: 153.2562642, lat: -27.71907},
{lng: 153.2499343, lat: -27.7171965},
{lng: 153.2472096, lat: -27.7119797},
{lng: 153.2336928, lat: -27.7103595},
{lng: 153.2297785, lat: -27.7118723},
{lng: 153.2267608, lat: -27.7154348},
{lng: 153.2168766, lat: -27.7150458},
{lng: 153.2135868, lat: -27.7236895},
{lng: 153.1953937, lat: -27.7216254},
{lng: 153.1919618, lat: -27.7289501},
{lng: 153.1844097, lat: -27.7286771},
{lng: 153.1629781, lat: -27.7259029},
{lng: 153.1597435, lat: -27.7206964},
{lng: 153.1242946, lat: -27.7150169},
{lng: 153.122706, lat: -27.7212931},
{lng: 153.115967, lat: -27.7266574},
{lng: 153.1146766, lat: -27.7325234},
{lng: 153.1195662, lat: -27.73687},
{lng: 153.1209332, lat: -27.7406251},
{lng: 153.1195537, lat: -27.7440763},
{lng: 153.1037303, lat: -27.7565112},
{lng: 153.1024967, lat: -27.7613509},
{lng: 153.1032041, lat: -27.7673577},
{lng: 153.1002961, lat: -27.7713484},
{lng: 153.0969538, lat: -27.7716728},
{lng: 153.0949393, lat: -27.7665947},
{lng: 153.0912084, lat: -27.7659214},
{lng: 153.0866143, lat: -27.7695802},
{lng: 153.0825758, lat: -27.770366},
{lng: 153.0700361, lat: -27.7631265},
{lng: 153.0655651, lat: -27.7593799},
{lng: 153.0639324, lat: -27.7567344},
{lng: 153.0647673, lat: -27.7545255},
{lng: 153.0690692, lat: -27.7517231},
{lng: 153.0686451, lat: -27.7502554},
{lng: 153.0647235, lat: -27.7505347},
{lng: 153.0597986, lat: -27.7520049},
{lng: 153.0567618, lat: -27.754994},
{lng: 153.0518591, lat: -27.767401},
{lng: 153.0500753, lat: -27.7699331},
{lng: 153.0462407, lat: -27.7729717},
{lng: 153.0429976, lat: -27.7745922},
{lng: 153.0412902, lat: -27.7737318},
{lng: 153.0413273, lat: -27.7699478},
{lng: 153.0394761, lat: -27.7661638},
{lng: 153.0350768, lat: -27.7620266},
{lng: 153.0327375, lat: -27.7622943},
{lng: 153.032007, lat: -27.7664754},
{lng: 153.0324341, lat: -27.7719512},
{lng: 153.0293397, lat: -27.7786496},
{lng: 153.026069, lat: -27.7789845},
{lng: 153.0234754, lat: -27.7802617},
{lng: 153.0234377, lat: -27.7848287},
{lng: 153.0228849, lat: -27.7877252},
{lng: 153.0216454, lat: -27.7891409},
{lng: 153.0175453, lat: -27.7879695},
{lng: 153.0163836, lat: -27.7842593},
{lng: 153.0150902, lat: -27.7830652},
{lng: 153.0121596, lat: -27.785385},
{lng: 153.0041523, lat: -27.7819745},
{lng: 152.9810298, lat: -27.7782673},
{lng: 152.980395, lat: -27.7816973},
{lng: 152.962395, lat: -27.7791785}
];

var zone4bCoords190211 = [
{lng: 153.2408763, lat: -27.6956846},
{lng: 153.2476044, lat: -27.6981201},
{lng: 153.2575607, lat: -27.6950803},
{lng: 153.2658005, lat: -27.6923444},
{lng: 153.2730103, lat: -27.6975122},
{lng: 153.2836533, lat: -27.6959923},
{lng: 153.291893, lat: -27.6932563},
{lng: 153.3047676, lat: -27.7096708},
{lng: 153.3202171, lat: -27.708759},
{lng: 153.3239937, lat: -27.682312},
{lng: 153.3163332, lat: -27.6523203},
{lng: 153.3165239, lat: -27.6288202},
{lng: 153.3108793, lat: -27.6080577},
{lng: 153.3105103, lat: -27.5966984},
{lng: 153.3197542, lat: -27.5817623},
{lng: 153.3128352, lat: -27.5657459},
{lng: 153.2949316, lat: -27.5561197},
{lng: 153.2868464, lat: -27.5416313},
{lng: 153.2948701, lat: -27.509944},
{lng: 153.2833163, lat: -27.5044595},
{lng: 153.2703896, lat: -27.5068913},
{lng: 153.260144, lat: -27.4797464},
{lng: 153.2450953, lat: -27.4775751},
{lng: 153.2444673, lat: -27.4677892},
{lng: 153.2397198, lat: -27.4628772},
{lng: 153.234462, lat: -27.4700333},
{lng: 153.2314981, lat: -27.4800782},
{lng: 153.2168834, lat: -27.4773149},
{lng: 153.2015833, lat: -27.4702856},
{lng: 153.1936426, lat: -27.4493708},
{lng: 153.1773162, lat: -27.4355627},
{lng: 153.201085, lat: -27.3533651},
{lng: 153.1887163, lat: -27.3431427},
{lng: 153.1687986, lat: -27.3694373},
{lng: 153.1529919, lat: -27.3981688},
{lng: 153.1402303, lat: -27.4213},
{lng: 153.1236644, lat: -27.4298326},
{lng: 153.1065413, lat: -27.4432395},
{lng: 153.1162173, lat: -27.4489902},
{lng: 153.1229007, lat: -27.4612727},
{lng: 153.1470538, lat: -27.4653954},
{lng: 153.1501001, lat: -27.4697474},
{lng: 153.1451641, lat: -27.474937},
{lng: 153.1538702, lat: -27.4762398},
{lng: 153.1590574, lat: -27.474877},
{lng: 153.1658699, lat: -27.4760723},
{lng: 153.1718945, lat: -27.4807056},
{lng: 153.1687354, lat: -27.4878517},
{lng: 153.1689027, lat: -27.493357},
{lng: 153.1717761, lat: -27.4938161},
{lng: 153.1732401, lat: -27.4954774},
{lng: 153.1773594, lat: -27.500056},
{lng: 153.1848454, lat: -27.501686},
{lng: 153.1864951, lat: -27.505143},
{lng: 153.2043251, lat: -27.5143756},
{lng: 153.2108264, lat: -27.5156904},
{lng: 153.2075299, lat: -27.5354332},
{lng: 153.2216429, lat: -27.5476537},
{lng: 153.2268125, lat: -27.5493499},
{lng: 153.2314575, lat: -27.5524809},
{lng: 153.2337802, lat: -27.5592969},
{lng: 153.234942, lat: -27.5663561},
{lng: 153.2314357, lat: -27.585954},
{lng: 153.2282167, lat: -27.5892836},
{lng: 153.2296968, lat: -27.6012938},
{lng: 153.2336987, lat: -27.6056261},
{lng: 153.2355284, lat: -27.6141812},
{lng: 153.2372466, lat: -27.6266118},
{lng: 153.235985, lat: -27.6342961},
{lng: 153.2401931, lat: -27.6373136},
{lng: 153.2386624, lat: -27.6505578},
{lng: 153.2325302, lat: -27.6630373},
{lng: 153.2260529, lat: -27.6817501},
{lng: 153.2407764, lat: -27.6875414},
{lng: 153.2450487, lat: -27.6915008},
{lng: 153.2408763, lat: -27.6956846}
];

var zone4cCoords190211 = [
{lng: 152.877566, lat: -27.5421854},
{lng: 152.8623962, lat: -27.5406967},
{lng: 152.8546715, lat: -27.5353693},
{lng: 152.848835, lat: -27.5318683},
{lng: 152.8417969, lat: -27.5288238},
{lng: 152.8313255, lat: -27.5308027},
{lng: 152.8258324, lat: -27.5318683},
{lng: 152.8203392, lat: -27.5312594},
{lng: 152.8170776, lat: -27.5288238},
{lng: 152.8100395, lat: -27.5277582},
{lng: 152.8035164, lat: -27.5311072},
{lng: 152.7964783, lat: -27.5352171},
{lng: 152.7902985, lat: -27.5356737},
{lng: 152.783432, lat: -27.5371959},
{lng: 152.7741623, lat: -27.5341516},
{lng: 152.7678108, lat: -27.5310312},
{lng: 152.7622358, lat: -27.5316108},
{lng: 152.7596195, lat: -27.536467},
{lng: 152.7656924, lat: -27.5442225},
{lng: 152.7647806, lat: -27.5493183},
{lng: 152.7536814, lat: -27.5558233},
{lng: 152.7479595, lat: -27.5639453},
{lng: 152.7418938, lat: -27.5659798},
{lng: 152.7400054, lat: -27.5625758},
{lng: 152.7210148, lat: -27.5633273},
{lng: 152.7185037, lat: -27.5642301},
{lng: 152.718074, lat: -27.5660107},
{lng: 152.7200477, lat: -27.571824},
{lng: 152.7230941, lat: -27.5739779},
{lng: 152.7257114, lat: -27.5765124},
{lng: 152.7225893, lat: -27.5827183},
{lng: 152.7195691, lat: -27.5842617},
{lng: 152.7172353, lat: -27.5873265},
{lng: 152.718249, lat: -27.5902013},
{lng: 152.720636, lat: -27.5926196},
{lng: 152.724962, lat: -27.596111},
{lng: 152.7299751, lat: -27.6018081},
{lng: 152.7241435, lat: -27.6173378},
{lng: 152.7244879, lat: -27.6217338},
{lng: 152.727579, lat: -27.6281071},
{lng: 152.7358222, lat: -27.6397886},
{lng: 152.7320568, lat: -27.6627134},
{lng: 152.7411814, lat: -27.6734393},
{lng: 152.7503351, lat: -27.6796892},
{lng: 152.7717405, lat: -27.6824584},
{lng: 152.7949931, lat: -27.6910354},
{lng: 152.8099168, lat: -27.6862948},
{lng: 152.8190073, lat: -27.688088},
{lng: 152.8267245, lat: -27.6862325},
{lng: 152.8373373, lat: -27.6778923},
{lng: 152.8468911, lat: -27.6739756},
{lng: 152.8383639, lat: -27.6685621},
{lng: 152.835159, lat: -27.6584353},
{lng: 152.8335735, lat: -27.6476601},
{lng: 152.8354213, lat: -27.6377972},
{lng: 152.8322227, lat: -27.636402},
{lng: 152.8206516, lat: -27.6351302},
{lng: 152.8140591, lat: -27.6315766},
{lng: 152.8086662, lat: -27.635254},
{lng: 152.8014565, lat: -27.6370029},
{lng: 152.7939034, lat: -27.6416411},
{lng: 152.7913284, lat: -27.6382955},
{lng: 152.7914143, lat: -27.6341134},
{lng: 152.7921867, lat: -27.6318322},
{lng: 152.7891827, lat: -27.6303113},
{lng: 152.784462, lat: -27.6291707},
{lng: 152.7828312, lat: -27.624532},
{lng: 152.778765, lat: -27.6239426},
{lng: 152.7800309, lat: -27.6164517},
{lng: 152.7828526, lat: -27.6168511},
{lng: 152.7834749, lat: -27.6136236},
{lng: 152.7828312, lat: -27.6135237},
{lng: 152.7839309, lat: -27.607943},
{lng: 152.782799, lat: -27.6077433},
{lng: 152.783362, lat: -27.6039118},
{lng: 152.7881926, lat: -27.6032892},
{lng: 152.7898157, lat: -27.6017186},
{lng: 152.7902371, lat: -27.5990832},
{lng: 152.788384, lat: -27.5974749},
{lng: 152.781106, lat: -27.598268},
{lng: 152.7794929, lat: -27.5958659},
{lng: 152.7810226, lat: -27.5918498},
{lng: 152.7859917, lat: -27.5856248},
{lng: 152.7958601, lat: -27.5828362},
{lng: 152.8041247, lat: -27.5828238},
{lng: 152.8096035, lat: -27.5833316},
{lng: 152.8115274, lat: -27.5864383},
{lng: 152.8145752, lat: -27.585911},
{lng: 152.8142603, lat: -27.5824085},
{lng: 152.8163038, lat: -27.5791483},
{lng: 152.8216087, lat: -27.5802244},
{lng: 152.8237954, lat: -27.5794309},
{lng: 152.8242021, lat: -27.5773795},
{lng: 152.8256387, lat: -27.5766594},
{lng: 152.8270007, lat: -27.5770886},
{lng: 152.8277833, lat: -27.5785639},
{lng: 152.8286947, lat: -27.5795255},
{lng: 152.8299708, lat: -27.5798215},
{lng: 152.8321138, lat: -27.5797483},
{lng: 152.8343211, lat: -27.5791236},
{lng: 152.8406885, lat: -27.5799088},
{lng: 152.84487, lat: -27.5810336},
{lng: 152.8490515, lat: -27.5824626},
{lng: 152.8529943, lat: -27.5827149},
{lng: 152.8545272, lat: -27.5829918},
{lng: 152.8554593, lat: -27.5846},
{lng: 152.8560791, lat: -27.5895091},
{lng: 152.8562697, lat: -27.5946463},
{lng: 152.8573188, lat: -27.596893},
{lng: 152.8597983, lat: -27.597512},
{lng: 152.8623597, lat: -27.5971735},
{lng: 152.8703906, lat: -27.5808618},
{lng: 152.8728416, lat: -27.579917},
{lng: 152.8765863, lat: -27.5800038},
{lng: 152.8889614, lat: -27.5900754},
{lng: 152.8932695, lat: -27.5977882},
{lng: 152.8981914, lat: -27.602352},
{lng: 152.9034416, lat: -27.6021078},
{lng: 152.905841, lat: -27.6009131},
{lng: 152.9060087, lat: -27.5972083},
{lng: 152.9008584, lat: -27.5893004},
{lng: 152.8953157, lat: -27.5823057},
{lng: 152.8941338, lat: -27.5788123},
{lng: 152.8955269, lat: -27.5749384},
{lng: 152.9000728, lat: -27.5696813},
{lng: 152.9014389, lat: -27.5658326},
{lng: 152.8973123, lat: -27.563125},
{lng: 152.8966752, lat: -27.5605029},
{lng: 152.9004785, lat: -27.5581718},
{lng: 152.9058265, lat: -27.5561449},
{lng: 152.9061963, lat: -27.5538964},
{lng: 152.8888632, lat: -27.5517532},
{lng: 152.8898233, lat: -27.5423272},
{lng: 152.877566, lat: -27.5421854}
];

var zonePOACoords190211 = [
{lng: 153.5584327, lat: -28.9458412},
{lng: 153.6530884, lat: -28.8583591},
{lng: 153.6669691, lat: -28.6474579},
{lng: 153.5875739, lat: -28.5136661},
{lng: 153.6072132, lat: -28.2219703},
{lng: 153.491048, lat: -28.0752154},
{lng: 153.4560253, lat: -27.9282982},
{lng: 153.3582135, lat: -27.7136641},
{lng: 153.3202171, lat: -27.708759},
{lng: 153.3047676, lat: -27.7096708},
{lng: 153.291893, lat: -27.6932563},
{lng: 153.2836533, lat: -27.6959923},
{lng: 153.2730103, lat: -27.6975122},
{lng: 153.2658005, lat: -27.6923444},
{lng: 153.2476044, lat: -27.6981201},
{lng: 153.2408763, lat: -27.6956846},
{lng: 153.2350703, lat: -27.6946592},
{lng: 153.2334546, lat: -27.6959703},
{lng: 153.2361657, lat: -27.7036934},
{lng: 153.2322856, lat: -27.7061111},
{lng: 153.2336928, lat: -27.7103595},
{lng: 153.2472096, lat: -27.7119797},
{lng: 153.2499343, lat: -27.7171965},
{lng: 153.2562642, lat: -27.71907},
{lng: 153.2692242, lat: -27.7209398},
{lng: 153.265525, lat: -27.7385138},
{lng: 153.258124, lat: -27.7491978},
{lng: 153.2434019, lat: -27.7516381},
{lng: 153.2405635, lat: -27.7553029},
{lng: 153.2441546, lat: -27.7612667},
{lng: 153.2334804, lat: -27.7663557},
{lng: 153.2296394, lat: -27.7698494},
{lng: 153.2287995, lat: -27.7743299},
{lng: 153.2216112, lat: -27.7725813},
{lng: 153.208642, lat: -27.7734835},
{lng: 153.19025, lat: -27.778318},
{lng: 153.1779033, lat: -27.800357},
{lng: 153.1003189, lat: -27.7938321},
{lng: 153.098259, lat: -27.8172156},
{lng: 153.1040955, lat: -27.8269319},
{lng: 153.055687, lat: -27.8600216},
{lng: 152.9936271, lat: -27.8436277},
{lng: 152.9861663, lat: -27.8310205},
{lng: 152.9639475, lat: -27.8250118},
{lng: 152.9470283, lat: -27.8156452},
{lng: 152.9458522, lat: -27.8120166},
{lng: 152.962395, lat: -27.7791785},
{lng: 152.965339, lat: -27.7639012},
{lng: 152.9375284, lat: -27.7609559},
{lng: 152.934331, lat: -27.7576749},
{lng: 152.9316276, lat: -27.7511846},
{lng: 152.9289885, lat: -27.749601},
{lng: 152.9155564, lat: -27.746889},
{lng: 152.9131565, lat: -27.7412958},
{lng: 152.9171118, lat: -27.7179113},
{lng: 152.9171121, lat: -27.713048},
{lng: 152.9124841, lat: -27.708203},
{lng: 152.900218, lat: -27.7021772},
{lng: 152.8961931, lat: -27.6947825},
{lng: 152.893861, lat: -27.6731124},
{lng: 152.8838055, lat: -27.6709005},
{lng: 152.8770845, lat: -27.6739251},
{lng: 152.8651882, lat: -27.6772366},
{lng: 152.8468911, lat: -27.6739756},
{lng: 152.8373373, lat: -27.6778923},
{lng: 152.8267245, lat: -27.6862325},
{lng: 152.8190073, lat: -27.688088},
{lng: 152.8099168, lat: -27.6862948},
{lng: 152.7949931, lat: -27.6910354},
{lng: 152.7717405, lat: -27.6824584},
{lng: 152.7503351, lat: -27.6796892},
{lng: 152.7411814, lat: -27.6734393},
{lng: 152.7320568, lat: -27.6627134},
{lng: 152.7358222, lat: -27.6397886},
{lng: 152.727579, lat: -27.6281071},
{lng: 152.7244879, lat: -27.6217338},
{lng: 152.7241435, lat: -27.6173378},
{lng: 152.7299751, lat: -27.6018081},
{lng: 152.724962, lat: -27.596111},
{lng: 152.720636, lat: -27.5926196},
{lng: 152.718249, lat: -27.5902013},
{lng: 152.7172353, lat: -27.5873265},
{lng: 152.7195691, lat: -27.5842617},
{lng: 152.7225893, lat: -27.5827183},
{lng: 152.7257114, lat: -27.5765124},
{lng: 152.7233087, lat: -27.5742063},
{lng: 152.7200477, lat: -27.571824},
{lng: 152.718074, lat: -27.5660107},
{lng: 152.7185037, lat: -27.5642301},
{lng: 152.7210148, lat: -27.5633273},
{lng: 152.7400054, lat: -27.5625758},
{lng: 152.7418938, lat: -27.5659798},
{lng: 152.7479595, lat: -27.5639453},
{lng: 152.7536814, lat: -27.5558233},
{lng: 152.7647806, lat: -27.5493183},
{lng: 152.7656924, lat: -27.5442225},
{lng: 152.7596195, lat: -27.536467},
{lng: 152.7622358, lat: -27.5316108},
{lng: 152.7678108, lat: -27.5310312},
{lng: 152.7741623, lat: -27.5341516},
{lng: 152.783432, lat: -27.5371959},
{lng: 152.7902985, lat: -27.5356737},
{lng: 152.7964783, lat: -27.5352171},
{lng: 152.8100395, lat: -27.5277582},
{lng: 152.8170776, lat: -27.5288238},
{lng: 152.8203392, lat: -27.5312594},
{lng: 152.8258324, lat: -27.5318683},
{lng: 152.8417969, lat: -27.5288238},
{lng: 152.848835, lat: -27.5318683},
{lng: 152.8524546, lat: -27.53422},
{lng: 152.8623962, lat: -27.5406967},
{lng: 152.877566, lat: -27.5421854},
{lng: 152.8759408, lat: -27.5344044},
{lng: 152.8770623, lat: -27.52571},
{lng: 152.8803347, lat: -27.510148},
{lng: 152.8841524, lat: -27.4982074},
{lng: 152.8920492, lat: -27.4867339},
{lng: 152.9035483, lat: -27.4821358},
{lng: 152.922941, lat: -27.4769759},
{lng: 152.9218182, lat: -27.4621017},
{lng: 152.9032821, lat: -27.4240447},
{lng: 152.8895256, lat: -27.4204495},
{lng: 152.8705548, lat: -27.4176347},
{lng: 152.8574181, lat: -27.420919},
{lng: 152.8547143, lat: -27.409566},
{lng: 152.855444, lat: -27.3982129},
{lng: 152.8706113, lat: -27.389297},
{lng: 152.8807984, lat: -27.3799227},
{lng: 152.8776392, lat: -27.3755772},
{lng: 152.8723223, lat: -27.3616641},
{lng: 152.8642433, lat: -27.3491242},
{lng: 152.8526982, lat: -27.3444736},
{lng: 152.8445434, lat: -27.3307527},
{lng: 152.8469041, lat: -27.3181033},
{lng: 152.8487281, lat: -27.3193281},
{lng: 152.852773, lat: -27.320665},
{lng: 152.856217, lat: -27.3195615},
{lng: 152.8606805, lat: -27.3156911},
{lng: 152.8631698, lat: -27.312526},
{lng: 152.8676319, lat: -27.2935367},
{lng: 152.867675, lat: -27.2906476},
{lng: 152.8666882, lat: -27.2877585},
{lng: 152.8677187, lat: -27.2827433},
{lng: 152.8723534, lat: -27.2827817},
{lng: 152.8769878, lat: -27.2840402},
{lng: 152.8816223, lat: -27.283773},
{lng: 152.8961722, lat: -27.2760656},
{lng: 152.898361, lat: -27.26317},
{lng: 152.8986172, lat: -27.2381434},
{lng: 152.9039383, lat: -27.2230363},
{lng: 152.9276763, lat: -27.174255},
{lng: 152.9343975, lat: -27.1659039},
{lng: 152.9366552, lat: -27.1643101},
{lng: 152.942372, lat: -27.1641382},
{lng: 152.9509735, lat: -27.1671535},
{lng: 152.9563146, lat: -27.1678789},
{lng: 152.9544967, lat: -27.1725464},
{lng: 152.9533652, lat: -27.1777483},
{lng: 152.9531622, lat: -27.1836472},
{lng: 152.9830742, lat: -27.1868529},
{lng: 152.9824606, lat: -27.1720432},
{lng: 152.9909707, lat: -27.1692915},
{lng: 153.002214, lat: -27.1693702},
{lng: 153.0050459, lat: -27.1656303},
{lng: 153.0119562, lat: -27.1673442},
{lng: 153.024595, lat: -27.1606819},
{lng: 153.0290046, lat: -27.1593917},
{lng: 153.0372419, lat: -27.1626582},
{lng: 153.0563736, lat: -27.1428677},
{lng: 153.0670166, lat: -27.1236187},
{lng: 153.0878105, lat: -27.1054962},
{lng: 153.1140918, lat: -27.0959269},
{lng: 153.1426757, lat: -27.0932796},
{lng: 153.1650836, lat: -27.1046876},
{lng: 153.1862424, lat: -27.1082508},
{lng: 153.2115207, lat: -27.1032529},
{lng: 153.2215594, lat: -27.0767507},
{lng: 153.1751459, lat: -26.9864512},
{lng: 153.1562532, lat: -26.8875777},
{lng: 153.1471198, lat: -26.8320569},
{lng: 153.1599536, lat: -26.7881857},
{lng: 153.1502366, lat: -26.7507651},
{lng: 153.1473917, lat: -26.683911},
{lng: 153.1170053, lat: -26.638523},
{lng: 153.1294293, lat: -26.3502129},
{lng: 152.8094525, lat: -26.0712073},
{lng: 152.0887805, lat: -26.1630912},
{lng: 150.0546262, lat: -26.533827},
{lng: 150.1107462, lat: -28.2732919},
{lng: 151.7659623, lat: -28.71678},
{lng: 153.5584327, lat: -28.9458412}
];